



























import Vue from "vue";
import { Header } from "@/components/MyTabs.vue";
import Overview from "./ContainerInfo/Overview.vue";
import Log from "./ContainerInfo/Log.vue";
import { uuid } from "../../utils/uuid";
import { eventBus } from "../../utils/event";
const Tabs: Header[] = [
  { label: "概览", name: "tab1", uuid: uuid() },
  { label: "资源监控", name: "tab4", uuid: uuid() },
  { label: "容器", name: "tab5", uuid: uuid() }
];

const statusEnum = {
  RUNNING: "运行中",
  UPDATING: "更新中",
  ERROR: "异常"
};
export default Vue.extend({
  name: "ContainerInfo",
  components: {
    Overview,
    Log
  },
  props: { projectId: { type: String } },
  data() {
    return {
      Tabs,
      dialog: false,
      tabActive: "tab1",
      containerData: null as any,
      statusEnum,
      lineList: [
        { title: "CPU 负载(%)", name: "podCpuUsage" },
        { title: "内存使用量(MB)", name: "podMemoryUsage" },
        { title: "网络流出速率(bps)", name: "podNetBytesTransmitted" },
        { title: "网络流入速率(bps)", name: "podNetBytesReceived" }
      ]
    };
  },
  deactivated() {
    this.dialog = false;
    this.tabActive = "tab1";
  },
  watch: {
    tabActive(val) {
      const tab = Tabs.find(item => item.name === val);
      eventBus.$emit("setBeard", {
        name: (tab as Header).label,
        is4Path: true
      });
    }
  },
  methods: {
    show(data: any, tab: string) {
      this.containerData = data;
      this.tabActive = tab ? tab : "tab1";
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      // 此项设置会触发 tabActive watch
      // 导致 面包屑 触发 setBeard
      // 目前是在面包屑上加 $nextTick
      this.tabActive = "tab1";
    }
  }
});
